import CreditReportClient from '@/api/CampusAdmin/CreditReportsClient';

export default class CreditForecastReport {
  constructor() {
    this.creditReportClient = null;
    this.schoolId = 0;

    this.loading = true;

    this.individual = { }
    this.workshop = { }
  }

  initialize($http, schoolId) {
    this.creditReportClient = new CreditReportClient($http);
    this.schoolId = schoolId;

    return this;
  }

  async fetch() {
    try {
      this.loading = true;

      const response = await this.creditReportClient.getForecastReport(
        this.schoolId
      );

      this.individual = response.individual;
      this.workshop = response.workshop;

    } finally {
      this.loading = false;
    }
  }
}
